<!--<mat-checkbox  [(ngModel)]="params.value.value"></mat-checkbox>-->
<mat-slide-toggle #checkbox
                  [color]="'primary'"
                  *ngIf="params.value"
                  [formControl]="textFormControl"
                  (keydown.enter)="onEnter()"
></mat-slide-toggle>

